import React from "react";
import { FieldRendererProps } from "../types";
import { RadioGroup } from "../../../ui/index.ts";
import styles from "./shared.module.css"
import clsx from "clsx";

export default function ChoiceFieldRenderer({ question, field, readOnly, index }: FieldRendererProps) {
    const rawOptions = JSON.parse(question.optionsJson ?? "[]");
    const formattedValues = rawOptions.map((opt: any) => ({
        value: String(opt),
        label: String(opt),
    }));

    if (readOnly) {
        return <div className={styles.wrapper}>
            <label className={clsx(
              "sub-heading-md",
              styles.label)} htmlFor={field.name}>{question.question}</label>
            <p className={clsx("body-sm", styles.choiceValue)}>{field.state.value}</p>
        </div>;
    }

    const label = (index ?? false) !== false ? `${index}.  ${question.question}` : question.question;
    return <RadioGroup
        name={field.name}
        id={field.name}
        label={label}
        value={field.state.value}
        onChange={(e) => field.handleChange(e)}
        onBlur={field.handleBlur}
        error={field.state.meta.errors?.[0]?.message?.toString()}
        options={formattedValues}
        disabled={readOnly}
    />;
}